import React, { useState, useEffect, useReducer, useMemo } from 'react'
import axios from 'axios'
import List from './list'

const summary = props => {

  //cash
  const cashListReducer = (state, action) => {
    switch (action.type) {
      case 'SET':
        return action.payload;
      default:
          return state;
    }
  }
  const [cashList, dispatchCash] = useReducer(cashListReducer, []);

  //receivable
  const receivableListReducer = (state, action) => {
    switch (action.type) {
      case 'SET':
        return action.payload;
      default:
          return state;
    }
  }
  const [receivableList, dispatchReceivable] = useReducer(receivableListReducer, []);

  //payable
  const payableListReducer = (state, action) => {
    switch (action.type) {
      case 'SET':
        return action.payload;
      default:
          return state;
    }
  }
  const [payableList, dispatchPayable] = useReducer(payableListReducer, []);

  useEffect(() => {
    //cash
    axios
      .get('https://reacthookstodoapp.firebaseio.com/cash_in_hand.json')
      .then(result => {
        const data = result.data;
        const lists = [];
        for (const key in data) {
          lists.push({id: key, name: data[key].name, amount: data[key].amount})
        }
        dispatchCash({ type: 'SET', payload: lists })
      })
      .catch(err =>{
        console.log(err);
      })
    //receivable
    axios
      .get('https://reacthookstodoapp.firebaseio.com/receivable.json')
      .then(result => {
        const data = result.data;
        const lists = [];
        for (const key in data) {
          lists.push({id: key, name: data[key].name, amount: data[key].amount})
        }
        dispatchReceivable({ type: 'SET', payload: lists })
      })
      .catch(err =>{
        console.log(err);
      })
    //payable
    axios
      .get('https://reacthookstodoapp.firebaseio.com/payable.json')
      .then(result => {
        const data = result.data;
        const lists = [];
        for (const key in data) {
          lists.push({id: key, name: data[key].name, amount: data[key].amount})
        }
        dispatchPayable({ type: 'SET', payload: lists })
      })
      .catch(err =>{
        console.log(err);
      })

  }, [props.count]);

  return (
    <React.Fragment>
      <div style={{marginTop: '5px', padding: '5px', marginBottom: '20px' }}>
        <h3 style={{textAlign: 'center',color: '#2e8bcc'}}><span style={{borderBottom: '2px solid #2e8bcc'}}>SUMMARY</span></h3>
        <List cashList={cashList} receivableList={receivableList} payableList={payableList} />
      </div>
    </React.Fragment>
  )
 
}

export default summary;


// WEBPACK FOOTER //
// ./src/components/Summary/index.js